import { defineMessages } from 'react-intl'

export default defineMessages({
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
    noValidError: {
        defaultMessage: 'No es válido',
    },
    phoneLabel: {
        defaultMessage: 'Teléfono móvil',
    },
    phonePlaceholder: {
        defaultMessage: 'Ej: 000 000 000',
    },
    lengthError: {
        defaultMessage: 'Debe tener entre 9 y 15 caracteres',
    },
    numberError: {
        defaultMessage: 'Solamente debe contener números',
    },
    provinceLabel: {
        defaultMessage: 'Provincia',
    },
    provincePlaceholder: {
        defaultMessage: 'Introduce la provincia',
    },
    addressLabel: {
        defaultMessage: 'Dirección de la plaza de garaje',
    },
    addressPlaceholder: {
        defaultMessage: '¿Dónde está tu garaje?',
    },
    emailLabel: {
        defaultMessage: 'Email',
    },
    emailPlaceholder: {
        defaultMessage: 'Email de empresa del contacto',
    },
    nameLabel: {
        defaultMessage: 'Nombre',
    },
    namePlaceholder: {
        defaultMessage: 'Introduce el nombre de la persona de contacto',
    },
    companyNameLabel: {
        defaultMessage: 'Empresa',
    },
    companyNamePlaceholder: {
        defaultMessage: 'Nombre de la empresa',
    },
    knowUsLabel: {
        defaultMessage: '¿Cómo nos has conocido?',
    },
    knowUsPlaceholder: {
        defaultMessage: 'Selecciona una opción',
    },
    knowUsOptionSocial: {
        defaultMessage: 'Redes sociales',
    },
    knowUsOptionRecommendation: {
        defaultMessage: 'Recomendación',
    },
    knowUsOptionRadio: {
        defaultMessage: 'Radio',
    },
    knowUsOptionTV: {
        defaultMessage: 'Televisión',
    },
    knowUsOptionUser: {
        defaultMessage: 'Soy usuario {tradename}',
    },
    employeesLabel: {
        defaultMessage: 'Tamaño',
    },
    employeesPlaceholder: {
        defaultMessage: 'Selecciona el tamaño',
    },
    employeesPlaceholderNative: {
        defaultMessage: 'Número de empleados',
    },
    employeesOptionMinus5: {
        defaultMessage: 'Menos de 5',
    },
    employeesOption5to25: {
        defaultMessage: 'Entre 5 a 25',
    },
    employeesOption26to50: {
        defaultMessage: 'Entre 26 a 50',
    },
    employeesOptionUp50: {
        defaultMessage: 'Más de 50',
    },
    fleetNameLabel: {
        defaultMessage: 'Nombre de la flota',
    },
    fleetNamePlaceholder: {
        defaultMessage: 'Introduce el nombre',
    },
    fleetNumberLabel: {
        defaultMessage: 'Número de camiones',
    },
    fleetNumberPlaceholder: {
        defaultMessage: 'Selecciona el número',
    },
    fleetNumberPlaceholderNative: {
        defaultMessage: 'Número de camiones',
    },
    fleetNumberOptionMinus50: {
        defaultMessage: 'Menos de 50',
    },
    fleetNumberOption50to259: {
        defaultMessage: '50 a 259',
    },
    fleetNumberOption260to500: {
        defaultMessage: '260 a 500',
    },
    fleetNumberOptionUp500: {
        defaultMessage: 'Más de 500',
    },
    parkingNameLabel: {
        defaultMessage: 'Nombre del parking',
    },
    parkingNamePlaceholder: {
        defaultMessage: 'Introduce el nombre',
    },
    parkingLotsNumberLabel: {
        defaultMessage: 'Número de plazas',
    },
    parkingLotsNumberPlaceholder: {
        defaultMessage: 'Selecciona el número',
    },
    parkingLotsNumberPlaceholderNative: {
        defaultMessage: 'Número de plazas',
    },
    parkingLotsNumberOptionMinus50: {
        defaultMessage: 'Menos de 50',
    },
    parkingLotsNumberOption50to259: {
        defaultMessage: '50 a 259',
    },
    parkingLotsNumberOption260to500: {
        defaultMessage: '260 a 500',
    },
    parkingLotsNumberOptionUp500: {
        defaultMessage: 'Más de 500',
    },
})
